/**
 *  @since: 2020-05-18
 *  @author: tams_dev1
 */

import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtForbiddenWordListUrl: '/api/op/as/forbidden-word/profiles',
  txtForbiddenWordListCommitUrl: '/api/op/as-forbidden-word-profiles',
  // 선택한 row 데이터
  rowSelectItems: {},
  rowSelectItemsSubTable: {},
  getForbiddenWordListData: [],
  getPatternListData: []
})

export const mutations = {
  clearStore: (state) => {
    state.rowSelectItems = {}
    state.rowSelectItemsSubTable = {}
    state.getForbiddenWordListData = []
    state.getPatternListData = []
  },
  setRowSelectItems: (state, data) => {
    state.rowSelectItems = _.cloneDeep(data)
  },
  setRowSelectItemsSubTable: (state, data) => {
    state.rowSelectItemsSubTable = _.cloneDeep(data)
  },
  subTableHeaderMutation: (state, data) => {
    state.getPatternListData = _.map(state.getPatternListData, (item) => {
      item.ban_word_use = data
      return item
    })
  },
  getForbiddenWordListDataAction: (state, data) => {
    state.getForbiddenWordListData = _.cloneDeep(data)
  },
  getPatternListDataAction: (state, data) => {
    state.getPatternListData = _.cloneDeep(data)
  },
  addForbiddenWordListDataAction: (state, data) => {
    state.getForbiddenWordListData.push(data)
  },
  editForbiddenWordListDataAction: (state, data) => {
    state.getForbiddenWordListData = _.map(state.getForbiddenWordListData, (item) => {
      if (item.ban_word_list_id === data.ban_word_list_id) {
        item.ban_word_list_uname = _.cloneDeep(data.ban_word_list_uname)
        item.ban_word_list_desc = _.cloneDeep(data.ban_word_list_desc)
      }
      return item
    })
  },
  addSubTable: (state, data) => {
    state.getPatternListData.push(data)
  },
  editSubTable: (state, data) => {
    state.getPatternListData = _.map(state.getPatternListData, (item) => {
      if (item.ban_word_id === data.ban_word_id) {
        item = _.cloneDeep(data)
      }
      return item
    })
  }
}

export const actions = {
  // 금지단어목록 조회
  async getForbiddenWordListDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.txtForbiddenWordListUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getForbiddenWordListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어패턴 조회
  async getPatternListDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}/items`)
      return resultFactory(commit, {length: null, data: data, action: 'getPatternListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어목록 추가
  async addForbiddenWordListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.txtForbiddenWordListUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addForbiddenWordListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어목록 수정
  async editForbiddenWordListDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editForbiddenWordListDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어목록 삭제
  async delForbiddenWordListDataAction ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItems.length > 1) {
      isMulty = true
      state.rowSelectItems.forEach((item) => {
        idList.push({'ban_word_list_id': item.ban_word_list_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.txtForbiddenWordListUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어패턴 추가
  async addSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}/items`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어패턴 수정
  async editSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}/items/${state.rowSelectItemsSubTable[0].ban_word_id}`, payload)
      return resultFactory(commit, {length: null, data: data, action: 'editSubTable', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어패턴 일괄수정
  async editAllSubTable ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}/items`, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어패턴 삭제
  async delSubTable ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.rowSelectItemsSubTable.length > 1) {
      isMulty = true
      state.rowSelectItemsSubTable.forEach((item) => {
        idList.push({'ban_word_list_id': state.rowSelectItems[0].ban_word_list_id, 'ban_word_id': item.ban_word_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}/items`, {data: {items: idList}}, {failAlert: false})
        : await this.$axios.$delete(`${state.txtForbiddenWordListUrl}/${state.rowSelectItems[0].ban_word_list_id}/items/${state.rowSelectItemsSubTable[0].ban_word_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 금지단어 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.txtForbiddenWordListCommitUrl}/${type}`, null, msg)
      return resultFactory(commit, {length: null, data: data, action: null, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
